import { useEffect, useState } from 'react'
import { fileFile } from '../../../../modules/uploadfiles/hooks'
import { DOWNLOAD_ACCEPT_TEMP } from '../../../../api/orderManage'
import { message } from 'antd'
import { orderStateEnum } from '../../../../global/enums'

export interface OrderInfo {
  acceptList: any[]
  accountNo: string // 关联报备单
  address: string
  checkState?: string // 判断审核状态
  consignee: string
  createTime: string
  customer: string
  id: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderState: string
  platform: string
  price: number
  progress: string
  refundPrice: number
  settlePrice: number
}

export interface Props {
  infoObj: OrderInfo
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}
export default function useHook(props: Props) {
  const { infoObj } = props

  const [uploadfilesList, setUploadfilesList] = useState<fileFile[]>([])
  const getStateColor = () => {
    const stateDesp =
      orderStateEnum.getLabelByValue(infoObj?.orderState as any) ?? ''
    if (['完成', '已完成', '待履约'].includes(stateDesp)) {
      return 'black'
    } else if (['已取消', '已退货'].includes(infoObj?.orderState)) {
      return 'red'
    } else {
      return 'orange'
    }
  }

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadfilesList(e)
  }
  const handleOrderTempDownload = async () => {
    await DOWNLOAD_ACCEPT_TEMP({ id: infoObj?.id })
  }
  useEffect(() => {
    setUploadfilesList(infoObj?.acceptList || [])
    // eslint-disable-next-line
  }, [infoObj?.acceptList])

  // 不能上传验收单时的提示
  const uploadMessage = () => {
    message.warn('未发货的订单不能上传验收单')
  }

  return {
    infoObj,
    uploadfilesList,
    handleUploadfilesChange,
    getStateColor,
    handleOrderTempDownload,
    uploadMessage,
  }
}
import { useEffect, useState } from 'react'
import { fileFile } from '../../../../modules/uploadfiles/hooks'
import { DOWNLOAD_ACCEPT_TEMP } from '../../../../api/orderManage'
import { message } from 'antd'
import { orderStateEnum } from '../../../../global/enums'

export interface OrderInfo {
  acceptList: any[]
  accountNo: string // 关联报备单
  address: string
  checkState?: string // 判断审核状态
  consignee: string
  createTime: string
  customer: string
  id: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderState: string
  platform: string
  price: number
  progress: string
  refundPrice: number
  settlePrice: number
}

export interface Props {
  infoObj: OrderInfo
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}
export default function useHook(props: Props) {
  const { infoObj } = props

  const [uploadfilesList, setUploadfilesList] = useState<fileFile[]>([])
  const getStateColor = () => {
    const stateDesp =
      orderStateEnum.getLabelByValue(infoObj?.orderState as any) ?? ''
    if (['完成', '已完成', '待履约'].includes(stateDesp)) {
      return 'black'
    } else if (['已取消', '已退货'].includes(infoObj?.orderState)) {
      return 'red'
    } else {
      return 'orange'
    }
  }

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadfilesList(e)
  }
  const handleOrderTempDownload = async () => {
    await DOWNLOAD_ACCEPT_TEMP({ id: infoObj?.id })
  }
  useEffect(() => {
    setUploadfilesList(infoObj?.acceptList || [])
    // eslint-disable-next-line
  }, [infoObj?.acceptList])

  // 不能上传验收单时的提示
  const uploadMessage = () => {
    message.warn('未发货的订单不能上传验收单')
  }

  return {
    infoObj,
    uploadfilesList,
    handleUploadfilesChange,
    getStateColor,
    handleOrderTempDownload,
    uploadMessage,
  }
}
